import React from "react";
import type { PerformanceBand } from "../../types/supplier-performance.types";
import { getBandConfig, getBandConfigForScore } from "../../constants/performance-bands";

interface PerformanceBadgeProps {
	band?: PerformanceBand | null;
	score: number | null;
	showScore?: boolean;
	size?: "sm" | "md" | "lg";
}

const sizeClasses: Record<string, string> = {
	sm: "px-2 py-0.5 text-xs",
	md: "px-2.5 py-1 text-sm",
	lg: "px-3 py-1.5 text-base",
};

export const PerformanceBadge: React.FC<PerformanceBadgeProps> = ({
	score,
	band,
	size = "md",
	showScore = true,
}) => {
	if (score === null && !band) {
		return (
			<span
				className={`inline-flex items-center rounded-full bg-gray-100 font-medium text-gray-500 ${sizeClasses[size]}`}
				data-testid="performance-badge-unrated"
			>
				Unrated
			</span>
		);
	}

	const bandConfig = band
		? getBandConfig(band)
		: getBandConfigForScore(score);

	if (!bandConfig) {
		return (
			<span
				className={`inline-flex items-center rounded-full bg-gray-100 font-medium text-gray-500 ${sizeClasses[size]}`}
				data-testid="performance-badge-unrated"
			>
				Unrated
			</span>
		);
	}

	return (
		<span
			className={`inline-flex items-center rounded-full font-medium ${bandConfig.bgColor} ${bandConfig.color} ${sizeClasses[size]}`}
			data-testid={`performance-badge-${bandConfig.band}`}
		>
			{showScore && score !== null && (
				<span className="mr-1 font-semibold">{Number(score).toFixed(1)}</span>
			)}
			{bandConfig.label}
		</span>
	);
};
